import { createActions } from 'redux-actions'

export const INIT_MASTER_PRODUCT_INFO = "INIT_CATEGORY_INFO";

export const REQUEST_MASTER_PRODUCT_START = "REQUEST_MASTER_PRODUCT_START";
export const REQUEST_MASTER_PRODUCT_SUCCESS = "REQUEST_MASTER_PRODUCT_SUCCESS";
export const REQUEST_ALL_MASTER_PRODUCT_SUCCESS = "REQUEST_ALL_MASTER_PRODUCT_SUCCESS";
export const REQUEST_MASTER_PRODUCT_FAIL = "REQUEST_MASTER_PRODUCT_FAIL";

export const POST_MASTER_PRODUCT_START = "POST_MASTER_PRODUCT_START";
export const POST_MASTER_PRODUCT_SUCCESS = "POST_MASTER_PRODUCT_SUCCESS";
export const POST_MASTER_PRODUCT_FAIL = "POST_MASTER_PRODUCT_FAIL";

export const PATCH_MASTER_PRODUCT_START = "PATCH_MASTER_PRODUCT_START";
export const PATCH_MASTER_PRODUCT_SUCCESS = "PATCH_MASTER_PRODUCT_SUCCESS";

export const DELETE_MASTER_PRODUCT_START = "DELETE_MASTER_PRODUCT_START";
export const DELETE_MASTER_PRODUCT_SUCCESS = "DELETE_MASTER_PRODUCT_SUCCESS";
export const DELETE_MASTER_PRODUCT_FAIL = "DELETE_MASTER_PRODUCT_FAIL";

export const REQUEST_DETAIL_MASTER_PRODUCT_START = "REQUEST_DETAIL_MASTER_PRODUCT_START";
export const REQUEST_DETAIL_MASTER_PRODUCT_SUCCESS = "REQUEST_DETAIL_MASTER_PRODUCT_SUCCESS";
export const REQUEST_DETAIL_MASTER_PRODUCT_FAIL = "REQUEST_DETAIL_MASTER_PRODUCT_FAIL";

export const PUT_MASTER_PRODUCT_START = "PUT_MASTER_PRODUCT_START";
export const PUT_MASTER_PRODUCT_SUCCESS = "PUT_MASTER_PRODUCT_SUCCESS";
export const PUT_MASTER_PRODUCT_FAIL = "PUT_MASTER_PRODUCT_FAIL";

export const DELETE_MULTIPLE_MASTER_PRODUCT_START = "DELETE_MULTIPLE_MASTER_PRODUCT_START";
export const DELETE_MULTIPLE_MASTER_PRODUCT_SUCCESS = "DELETE_MULTIPLE_MASTER_PRODUCT_SUCCESS";
export const DELETE_MULTIPLE_MASTER_PRODUCT_FAIL = "DELETE_MULTIPLE_MASTER_PRODUCT_FAIL";

export const PATCH_MULTIPLE_MASTER_PRODUCT_START = "PATCH_MULTIPLE_MASTER_PRODUCT_START";
export const PATCH_MULTIPLE_MASTER_PRODUCT_SUCCESS = "PATCH_MULTIPLE_MASTER_PRODUCT_SUCCESS";
export const PATCH_MULTIPLE_MASTER_PRODUCT_FAIL = "PATCH_MULTIPLE_MASTER_PRODUCT_FAIL";

export const PUT_MULTIPLE_MASTER_PRODUCT_START = "PUT_MULTIPLE_MASTER_PRODUCT_START";
export const PUT_MULTIPLE_MASTER_PRODUCT_SUCCESS = "PUT_MULTIPLE_MASTER_PRODUCT_SUCCESS";
export const PUT_MULTIPLE_MASTER_PRODUCT_FAIL = "PUT_MULTIPLE_MASTER_PRODUCT_FAIL";

export const CHECK_BARCODE_START = "CHECK_BARCODE_START";
export const CHECK_BARCODE_SUCCESS = "CHECK_BARCODE_SUCCESS";
export const CHECK_BARCODE_FAIL = "CHECK_BARCODE_FAIL";

export const IMPORT_MASTER_PRODUCT_START = "IMPORT_MASTER_PRODUCT_START";
export const IMPORT_MASTER_PRODUCT_SUCCESS = "IMPORT_MASTER_PRODUCT_SUCCESS";
export const IMPORT_MASTER_PRODUCT_FAIL = "IMPORT_MASTER_PRODUCT_FAIL";

export const REQUEST_IMPORT_MASTER_PRODUCT_START = "REQUEST_IMPORT_MASTER_PRODUCT_START";
export const REQUEST_IMPORT_MASTER_PRODUCT_SUCCESS = "REQUEST_IMPORT_MASTER_PRODUCT_SUCCESS";
export const REQUEST_IMPORT_MASTER_PRODUCT_FAIL = "REQUEST_IMPORT_MASTER_PRODUCT_FAIL";

export const SEARCH_PRODUCT_START = "SEARCH_PRODUCT_START";
export const SEARCH_PRODUCT_SUCCESS = "SEARCH_PRODUCT_SUCCESS";
export const SEARCH_PRODUCT_FAIL = "SEARCH_PRODUCT_FAIL";

export const {

    initMasterProductInfo,
    requestMasterProductStart,
    requestMasterProductSuccess,
    requestAllMasterProductSuccess,
    requestMasterProductFail,

    postMasterProductStart,
    postMasterProductSuccess,
    postMasterProductFail,

    patchMasterProductStart,
    patchMasterProductSuccess,

    deleteMasterProductStart,
    deleteMasterProductSuccess,
    deleteMasterProductFail,

    requestDetailMasterProductStart,
    requestDetailMasterProductSuccess,
    requestDetailMasterProductFail,

    putMasterProductStart,
    putMasterProductSuccess,
    putMasterProductFail,

    deleteMultipleMasterProductStart,
    deleteMultipleMasterProductSuccess,
    deleteMultipleMasterProductFail,

    patchMultipleMasterProductStart,
    patchMultipleMasterProductSuccess,
    patchMultipleMasterProductFail,

    putMultipleMasterProductStart,
    putMultipleMasterProductSuccess,
    putMultipleMasterProductFail,

    checkBarcodeStart,
    checkBarcodeSuccess,
    checkBarcodeFail,

   importMasterProductStart,
   importMasterProductSuccess,
   importMasterProductFail,


   requestImportMasterProductStart,
   requestImportMasterProductSuccess,
   requestImportMasterProductFail,

   searchProductStart,
   searchProductSuccess,
   searchProductFail,

} = createActions({

    [INIT_MASTER_PRODUCT_INFO]: (req) => ({ req }),

    [REQUEST_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [REQUEST_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [REQUEST_ALL_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [REQUEST_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [POST_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [POST_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [POST_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [PATCH_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [PATCH_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),

    [DELETE_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [DELETE_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [DELETE_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [REQUEST_DETAIL_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [REQUEST_DETAIL_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [REQUEST_DETAIL_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [PUT_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [PUT_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [PUT_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [DELETE_MULTIPLE_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [DELETE_MULTIPLE_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [DELETE_MULTIPLE_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [PATCH_MULTIPLE_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [PATCH_MULTIPLE_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [PATCH_MULTIPLE_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [PUT_MULTIPLE_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [PUT_MULTIPLE_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [PUT_MULTIPLE_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [CHECK_BARCODE_START]: (req) => ({ ...req }),
    [CHECK_BARCODE_SUCCESS]: (res) => ({ res }),
    [CHECK_BARCODE_FAIL]: (res) => ({ res }),

    [IMPORT_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [IMPORT_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [IMPORT_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [REQUEST_IMPORT_MASTER_PRODUCT_START]: (req) => ({ ...req }),
    [REQUEST_IMPORT_MASTER_PRODUCT_SUCCESS]: (res) => ({ res }),
    [REQUEST_IMPORT_MASTER_PRODUCT_FAIL]: (res) => ({ res }),

    [SEARCH_PRODUCT_START]: (req) => ({ ...req }),
    [SEARCH_PRODUCT_SUCCESS]: (res) => ({ res }),
    [SEARCH_PRODUCT_FAIL]: (res) => ({ res }),
})


